import PanelNav from "../Components/Panel/PanelNav";
import Infopage from "../Components/Panel/Infopage";
import Layout from "./Layout";
// import { Link } from "react-router-dom";

export default function Panel() {
  return (
    <Layout>
      <section className="h-auto mx-auto max-w-screen-xl px-4 grid grid-cols-1 lg:grid-cols-6 xl:grid-cols-5 w-full my-6">
        <PanelNav />
        <Infopage />
      </section>
    </Layout>
  );
}
